import type { ProtonThunkArguments } from '@proton/redux-shared-store-types';

export interface DriveThunkArguments extends ProtonThunkArguments {}

export const extraThunkArguments = {} as DriveThunkArguments;
